import * as Types from '@trello/graphql/generated';

import { useQuickLoad } from '@trello/quickload';
import type { TrelloQueryHookOptions, TrelloLazyQueryHookOptions, TrelloSuspenseQueryHookOptions } from '@trello/quickload';
import DocumentNode from '@trello/graphql/src/documentNode';
import * as Apollo from '@apollo/client';
export const CreatePluginTeamsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CreatePluginTeams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"member"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"StringValue","value":"me","block":false}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"agreements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"agreementType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organizations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"memberships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"idMember"}},{"kind":"Field","name":{"kind":"Name","value":"memberType"}}]}}]}}]}}]}}]} as unknown as DocumentNode;
const defaultOptions = {"context":{"operationName":"CreatePluginTeams","document":CreatePluginTeamsDocument}} as const;
export type CreatePluginTeamsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type CreatePluginTeamsQuery = (
  { __typename: 'Query' }
  & { member?: Types.Maybe<(
    { __typename: 'Member' }
    & Pick<Types.Member, 'id'>
    & { agreements: Array<(
      { __typename: 'Member_Agreement' }
      & Pick<Types.Member_Agreement, 'id' | 'agreementType'>
    )>, organizations: Array<(
      { __typename: 'Organization' }
      & Pick<Types.Organization, 'id' | 'displayName'>
      & { memberships: Array<(
        { __typename: 'Organization_Membership' }
        & Pick<Types.Organization_Membership, 'id' | 'idMember' | 'memberType'>
      )> }
    )> }
  )> }
);

/**
 * __useCreatePluginTeamsQuery__
 *
 * To run a query within a React component, call `useCreatePluginTeamsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreatePluginTeamsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreatePluginTeamsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCreatePluginTeamsQuery(
  baseOptions?: TrelloQueryHookOptions<
    CreatePluginTeamsQuery,
    CreatePluginTeamsQueryVariables
  >,
) {
  const isQuickLoading = useQuickLoad({
    waitOn: baseOptions?.waitOn || ['None'],
    document: CreatePluginTeamsDocument,
    skip: baseOptions?.skip,
  });
  const options = {
    ...defaultOptions,
    ...baseOptions,
    skip: isQuickLoading || baseOptions?.skip,
  };
  const result = Apollo.useQuery<
    CreatePluginTeamsQuery,
    CreatePluginTeamsQueryVariables
  >(CreatePluginTeamsDocument, options);
  // reconstruct result because modifying the useQuery result actually changes apollo behavior because of memoization
  const trelloResult = { ...result };
  if (isQuickLoading) {
    trelloResult.loading = true;
  }

  return trelloResult;
}
export function useCreatePluginTeamsLazyQuery(
  baseOptions?: TrelloLazyQueryHookOptions<
    CreatePluginTeamsQuery,
    CreatePluginTeamsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CreatePluginTeamsQuery,
    CreatePluginTeamsQueryVariables
  >(CreatePluginTeamsDocument, options);
}
export function useCreatePluginTeamsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | TrelloSuspenseQueryHookOptions<
        CreatePluginTeamsQuery,
        CreatePluginTeamsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    CreatePluginTeamsQuery,
    CreatePluginTeamsQueryVariables
  >(CreatePluginTeamsDocument, options);
}
export type CreatePluginTeamsQueryHookResult = ReturnType<
  typeof useCreatePluginTeamsQuery
>;
export type CreatePluginTeamsLazyQueryHookResult = ReturnType<
  typeof useCreatePluginTeamsLazyQuery
>;
export type CreatePluginTeamsSuspenseQueryHookResult = ReturnType<
  typeof useCreatePluginTeamsSuspenseQuery
>;
export type CreatePluginTeamsQueryResult = Apollo.QueryResult<
  CreatePluginTeamsQuery,
  CreatePluginTeamsQueryVariables
>;
